import useSWR from 'swr';
import {
    AutoCompleteEndpointMap,
    AutoCompleteKeyMap
} from '../../components/GrispiInput/components/GrispiAutoCompleteInput';
import { Group, customSWRConfig, customSWRResponse } from '../../model/types';
import { endUserPublicFetcher, fetcherWithToken } from '../../utils/fetchers';
import { nonNullishValue } from '../../utils/helpers';
import useSWRCacheKeys, { usePublicApiSWRCacheKeys } from '../useSWRCacheKeys';
import { AutocompleteResponseType } from './useAutocompleteSearch';

export default function useMultiAutocompleteItemsById(
    autocompleteKey: AutoCompleteKeyMap,
    autoCompleteKeyIds: string,
    isPublic: boolean = false,
    config: customSWRConfig = {}
): customSWRResponse<AutocompleteResponseType<Group>> {
    const keys = useSWRCacheKeys(
        autoCompleteKeyIds
            ? `/field-values/${AutoCompleteEndpointMap[autocompleteKey]}/options?ids=${autoCompleteKeyIds}`
            : null
    );
    const publicKeys = usePublicApiSWRCacheKeys(
        autoCompleteKeyIds
            ? `/field-values/${AutoCompleteEndpointMap[autocompleteKey]}/options?ids=${autoCompleteKeyIds}`
            : null
    );
    const isKeyExists = nonNullishValue(keys) || nonNullishValue(publicKeys);

    return useSWR<AutocompleteResponseType<Group>>(
        isKeyExists ? (isPublic ? publicKeys : keys) : null,
        isPublic ? endUserPublicFetcher : fetcherWithToken,
        { ...config }
    );
}
